import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { StkmaService, templateUrlConfigStk } from './../_service_stk';
import { Stkma } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stkma-edit',
  templateUrl: './stkma-editPkg.component.html',//templateUrlConfigStk.stkma,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
})

export class StkmaEditComponent extends JkDialogEditComponent<StkmaService, Stkma> {
  override dialogRef: MatDialogRef<StkmaEditComponent>;
  override data: jkRestReturn;

  override srv!: StkmaService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StkmaEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
